module.exports = __webpack_public_path__ + "static/media/IconNone.7e274ec2.svg";